import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {ConsentUseCaseBasicModel} from '@core/modules/rest/consent-use-case/response/consent-use-case-basic.model';
import {ConsentUseCaseLetterEnum} from '../../../consent-use-case/enums/consent-use-case.enum-letter';
import {LevelToIntensityPipe} from '@core/pipes/level-to-intensity.pipe';
import {UnitARequestModel} from '@core/modules/rest/consent/request/unit-a-request.model';
import {SliderResponseModel} from '@shared/components/slider/model/slider-response.model';
import {IntensityToLevelPipe} from '@core/pipes/intensity-to-level.pipe';
import {ProvisionDurationEnum} from '@core/modules/rest/indication/enums/provisionDurationEnum';

@Component({
    selector: 'app-wizard-step-consent-use-case-details',
    templateUrl: './wizard-step-consent-use-case-details.component.html',
    styleUrls: ['./wizard-step-consent-use-case-details.component.scss']
})

export class WizardStepConsentUseCaseDetailsComponent implements OnInit {

    @Input() cssClasses: string | undefined;
    @Input() durationInMillis: number | undefined;
    @Input() consentUseCases: ConsentUseCaseBasicModel[] | undefined;
    @Input() selectedUseCaseId: string | undefined;
    @Input() initialUseCaseDetails: ConsentUseCaseBasicModel | undefined;
    @Output() nextStepEvent: EventEmitter<void> = new EventEmitter();
    @Output() useCaseChapterChange: EventEmitter<UnitARequestModel> = new EventEmitter();
    @Output() provisionDurationChange: EventEmitter<ProvisionDurationEnum> = new EventEmitter();

    consentUseCaseValues: string[] = [];
    provisionDurationValues: string[] = [];
    provisionDuration = ProvisionDurationEnum.BASIC;
    useCaseDetails: ConsentUseCaseBasicModel | undefined;
    defaultUnitALevels: { unitId: string, unitLevel: ConsentUseCaseLetterEnum }[] = [];

    constructor(private levelToIntensityPipe: LevelToIntensityPipe, private intensityToLevelPipe: IntensityToLevelPipe) {
    }

    ngOnInit(): void {
        this.durationInMillis = this.durationInMillis === 0 ? this.initialUseCaseDetails?.durationInMilliseconds : this.durationInMillis;
        const tempConsentUseCaseValues = this.transformList(Object.keys(ConsentUseCaseLetterEnum));
        this.consentUseCaseValues = tempConsentUseCaseValues.slice(1);
        this.provisionDurationValues = this.transformProvisionDurationList(Object.keys(ProvisionDurationEnum));
        this.useCaseDetails = this.initialUseCaseDetails;
        this.getDefaultChapterLevels();
    }

    private getDefaultChapterLevels(): void {
        this.initialUseCaseDetails?.chapterUnits.forEach(item => {
            const oneChapter = {
                unitId: item.unitId,
                unitLevel: item.unitLevel
            };
            this.defaultUnitALevels.push(oneChapter);
        });
    }

    nextStepClick(): void {
        this.nextStepEvent.emit();
    }

    transformList(values: string[]): string[] {
        const transformedList: string[] = [];
        values.forEach(value => {
            transformedList.push(this.levelToIntensityPipe.transform(ConsentUseCaseLetterEnum[value as keyof typeof ConsentUseCaseLetterEnum]));
        });

        return transformedList;
    }

    transformProvisionDurationList(values: string[]): string[] {
        return values.map(value => {
                return ProvisionDurationEnum[value as keyof typeof ProvisionDurationEnum];
            }
        );
    }

    sliderChange(event: SliderResponseModel): void {
        const pipedIntensity = this.intensityToLevelPipe.transform(event.selected);
        const level = ConsentUseCaseLetterEnum[pipedIntensity as keyof typeof ConsentUseCaseLetterEnum];
        const unitARequestModel: UnitARequestModel = {
            unitId: event.id,
            unitLevel: level,
            provisionDuration: this.provisionDuration
        };

        this.useCaseChapterChange.emit(unitARequestModel);
    }

    relevanceChange(event: SliderResponseModel): void {
        this.provisionDuration = ProvisionDurationEnum[(event.selected) as keyof typeof ProvisionDurationEnum];
        this.provisionDurationChange.emit(this.provisionDuration);
    }
}
